import { render, staticRenderFns } from "./p295_article.vue?vue&type=template&id=8e756080"
import script from "./p295_article.vue?vue&type=script&lang=js"
export * from "./p295_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsCoreRow: require('/root/containers/hermes_eshop/components/core/elements/coreRow.vue').default,P295ArticleCard: require('/root/containers/hermes_eshop/components/hyper/p295/p295_article_card.vue').default})
